import { render, staticRenderFns } from "./FormRadios.vue?vue&type=template&id=229f7b58"
import script from "./FormRadios.vue?vue&type=script&lang=js"
export * from "./FormRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports